import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1t4cs4m-0"
})(["position:absolute;width:100%;opacity:", ";z-index:", ";transition:opacity 0.2s ease-in;"], function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? 1 : 0;
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? 1 : 0;
});